import { Inject, Injectable } from '@angular/core';
import { API_BASE_PLATFORM_URL } from './config.service';
import { Observable } from 'rxjs';
import { HttpUtility } from '@core/http';
import { GetStatesResponse } from '@core/model/getStatesResponse';
import { UrlConstants } from './url-constants';

@Injectable({
  providedIn: 'root'
})
export class StateSelectorService {

  constructor(
    @Inject(API_BASE_PLATFORM_URL) private apiBaseUrl: string,
    private httpUtility:HttpUtility){
  }

  getStates() : Observable<GetStatesResponse> {
      return this.httpUtility.get<GetStatesResponse>(
        `${this.apiBaseUrl}/${UrlConstants.getStates}`
      );
    }
}
